export enum MEMBER_ROLES {
  MANAGER = 'manager',
  MANAGER_READ_ONLY = 'managerReadOnly',
  MEMBER = 'member',
  OWNER = 'owner',
}
